
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/campaign-monitor",
      function () {
        return require("private-next-pages/destinations/campaign-monitor.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/campaign-monitor"])
      });
    }
  